import React, { useRef, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import Tooltip from '@mui/material/Tooltip';
import classNames from 'classnames';
import useStyles from './CodeSnippet.styles';

const CodeSnippet = ({ className, children }) => {
  const { classes } = useStyles();
  // references the element containing the code
  const codeRef = useRef(null);
  // the tooltip for the copy button
  const [tooltip, setTooltip] = useState('');
  // true if the copy button was clicked
  const [copied, setCopied] = useState(false);

  return (
    <div className={classNames(classes.root, className)}>
      <pre ref={codeRef}>
        <code>{children}</code>
      </pre>
      <Tooltip
        title={tooltip}
        onOpen={() => {
          // only reset the tooltip if the copy button wasn't clicked: this is needed since after clicking the copy
          // button and moving the mouse slightly, 'onOpen' gets called for some reason (even though the tooltip hasn't
          // been closed in the meantime)
          if (!copied) {
            setTooltip('Copy to clipboard');
          }
        }}
        onClose={() => setCopied(false)}
        placement="top"
        arrow
      >
        <IconButton
          size="small"
          onClick={async () => {
            const code = codeRef.current.textContent;
            await navigator.clipboard.writeText(code);
            setTooltip('Copied');
            setCopied(true);
          }}
        >
          <FileCopyIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default CodeSnippet;
